import React from 'react';
import { IconProps } from '.';

const SvgColoredReturn = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill='#787887'
        d='M18.627 8.373A7.25 7.25 0 0 0 13.5 6.25H9.64l1.1-1.1a1.75 1.75 0 0 0-2.475-2.475L3.97 6.97a1.457 1.457 0 0 0 0 2.06l4.294 4.295a1.748 1.748 0 0 0 2.474-2.47L9.637 9.75H13.5a3.731 3.731 0 0 1 3.75 3.75 3.731 3.731 0 0 1-3.75 3.75H7.25a1.75 1.75 0 0 0 0 3.5h6.25a7.25 7.25 0 0 0 5.127-12.377Z'
      />
    </svg>
  );
};

export default SvgColoredReturn;
